import { createSelector } from '@reduxjs/toolkit'
import { cartSlice } from '..'

export const cartItemsIdsSelector = createSelector(
  [cartSlice.selectors.items],
  (items) => Object.values(items).map((item) => item.id)
)
